import { Feature, IFeatureContext, IFeature } from './Feature';
import * as d3 from 'd3';
import { PixoSpatial, PixoPt } from '../Pixospatial';
import { getGeom } from '@turf/invariant';
import { lineString, Geometry, GeometryObject } from '@turf/helpers';
import { Vertex } from './Vertex';
import { Segment } from './Segment';

// tslint:disable-next-line: no-string-literal


export class LineFeature extends Feature implements IFeature {
	private segmentGroup: any;
	private pointGroup: any;
	private segments: Array<any>;
	private ending = 'end';
	public get type(): string {
		return 'line';
	}
	constructor(context: IFeatureContext, spatialContext: PixoSpatial = null) {
		super(context, spatialContext);
		this.segmentGroup = context.segmentGroup.append('g');
		this.pointGroup = context.pointGroup.append('g');

		this.segments = [];
		this.points = [];
		this.groups = [this.pointGroup, this.segmentGroup];
	}

	AddVertex(ptInfo, xProp = 'x', yProp = 'y') {
		let fromPt = null;
		let toPt = null;
    const lastSelect = this.lookup[this.lastSelection];
    if (lastSelect?.type === 'point') {
      const firstPointId = this.points[0].id;
      const lastPointId = this.points[this.points.length-1]?.id;
      if ((this.points.length > 0)) {
        if ([firstPointId, lastPointId].indexOf(lastSelect.id) === -1) {
          const seg = lastSelect.nextSeg();
          if (seg) {
            this.Select(seg.id);
            const newPt = seg.AddVertexFromCoord(ptInfo);
            this.Select(newPt.id);
            return;
          }

        }
      }
    }
		const pt: any = this.MakeVertex(this.points, this.pointGroup, ptInfo, xProp, yProp);
		if (!!this.lastSelection) {
			if (!!this.lookup[this.lastSelection]) {
				const lastSelect = this.lookup[this.lastSelection];
				if (lastSelect.type === 'point') {
					if (this.segments.length > 0) {
						const firstVertex = this.segments[0].from;
						let ending = null;
						if ((firstVertex.id === lastSelect.id)) {
							fromPt = pt;
							toPt = lastSelect;
							ending = 'start';
							this.points.unshift(this.points.pop());
						} else {
							fromPt = this.segments[this.segments.length - 1].to;
							toPt = pt;
							ending = 'end';
						}
						this.MakeSegment(this.points, this.pointGroup, this.segments, this.segmentGroup, fromPt, toPt, ending);
						this.Select(pt.id);
						return;
					}
				}
			}
		}
		const seg = this.MakeSegment(this.points, this.pointGroup, this.segments, this.segmentGroup);
		this.Select(pt.id);
		// tslint:disable-next-line: no-string-literal
    return pt;

	}
	Remove(): void {
		for (const pt of this.points) {
			if (!!this.lookup[pt.id]) {
				if (!!this.lookup[pt.id].ui) {
					this.lookup[pt.id].ui.on('.drag', null);
					this.lookup[pt.id].ui.on('mousedown', null);
				}
				delete this.lookup[pt.id];
			}
		}
		for (const segment of this.segments) {
			if (!!this.lookup[segment.id]) {
				this.lookup[segment.id].ui.on('mousedown', null);
			}
			delete this.lookup[segment.id];
		}
		this.segmentGroup.remove();
		this.pointGroup.remove();
	}
	ToGeoJSONGeom(): GeometryObject | false {
		if (this.points.length <= 1) {
			return false;
		}
		const coords = [];
		for (const pt of this.points) {
			const coord = pt.coord.spatial;
			coords.push([coord.lng, coord.lat]);
		}
		return getGeom(lineString(coords));
	}
	FromGeoJSONGeom(geom: Geometry) {
		if(!geom) {
			return;
		}
		for (const lineCoord of geom.coordinates) {

			const ptInfo: PixoPt = this.spatialContext.SpatialCoord({ lng: lineCoord[0], lat: lineCoord[1] }).convert();
			this.AddVertex(ptInfo);

		}
	}
  ToggleVis(isVis?:boolean) {
    let wasVis = !this.pointGroup.node().classList.contains('hidden');
    isVis = (isVis !== undefined) ? isVis : !wasVis;
    this.pointGroup.node().classList.toggle('hidden',!isVis);
    this.segmentGroup.node().classList.toggle('hidden',!isVis);
  }
  GetVis():boolean {
    return !this.pointGroup.node().classList.contains('hidden');
  }
}
